import styled, { css } from 'styled-components'
import bg1 from '@images/bgs/bg1.png'

export const Wrapper = styled.section`
  z-index: 1000;
  overflow: hidden;
  position: relative;
  background: ${({ bgColor }) =>
    bgColor === 'white' ? 'var(--bg-white-color)' : 'none'};
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: ${({ center }) => (center ? 'center' : 'flex-start')};
  justify-content: center;
  padding: 100px 0;
`
